import { gql } from '@apollo/client';

const UPDATE_LISTING_CONTACT = gql`
    mutation UpdateListingContact($params: UpdateListingContactsParams!) {
        updateListingContact(params: $params)
    }
`;

export default UPDATE_LISTING_CONTACT;
